import { Link } from "react-router-dom";

export const projects = [
  {
    id: 21,
    url: "ation-tech-service-platform",
    title: "Ation Tech | Service Platform",
    location: "Milano, Italy",
    tag: ["Software Development", "UI", "UX", "Web Development"],
    client: "Avid Technology",
    avatar: [require("../assets/Ation-Tech-Service-Platform_Avatar.png")],
    images: [
      require("../assets/Ation-Tech-Service-Platform_Homepage.png"),
    ],
    videos: [],
    embeds: [
      {
        url: "https://www.linkedin.com/posts/ation-tech_the-future-of-broadcast-automation-activity-7406996601010864128-AE_K?utm_source=share&utm_medium=member_desktop&rcm=ACoAABEbX_oBJgZZ8ssByYK6M98tWHh6wplK1PQ",
        title: "Ation Tech continues to evolve",
        subtitle: "Expanding the Ation Service Platform into a broader ecosystem of automation, intelligence, and scalability.",
        thumbnail: require("../assets/Ation-Tech-Service-Platform_Video-thumbnail.png"),
      },
      {
        url: "https://www.linkedin.com/posts/ation-tech_ation-service-platform-202511-activity-7404467738313846784-_402?utm_source=share&utm_medium=member_desktop&rcm=ACoAABEbX_oBJgZZ8ssByYK6M98tWHh6wplK1PQ",
        title: "Ation Tech | Service Platform - latest release",
        subtitle: "The latest release introduces major upgrades designed for modern broadcast infrastructures.",
        thumbnail: require("../assets/Ation-Tech-Service-Platform_Video-thumbnail.png"),
      },
      {
        url: "https://www.linkedin.com/posts/ation-tech_automation-you-can-trust-activity-7400111232554401792-7DQk?utm_source=share&utm_medium=member_desktop&rcm=ACoAABEbX_oBJgZZ8ssByYK6M98tWHh6wplK1PQ",
        title: "Reliability and security, the core of Ation Tech.",
        subtitle: "Every automation routine — from reboots to validation checks — is designed to ensure consistency, transparency, and control.",
        thumbnail: require("../assets/Ation-Tech-Service-Platform_Video-thumbnail.png"),
      },
    ],
    graphicToolsUsed: ["Figma"],
    codingToolsUsed: ["HTML", "CSS", "Javascript", "Vue", "Git", "Golang", "PostgreSQL", "Docker", "Linux"],
    description: [
      "Visit ", 
      <Link to="https://ation.it" target="_blank" key={0}> Ation Tech website </Link>, " to learn more about the Ation Service Platform, or use the video links above to watch short project presentations published on LinkedIn.", 
      <br key={0} />,
      <br key={1} />,
      "This project was developed as part of my full-time role at Avid Technology (Avid Italy Srl), where I work as a Junior Software Developer within a small development team. The platform is a production-ready enterprise software solution designed to support Avid technical support teams in managing and assisting customers using Avid software products and related infrastructures, with a particular focus on MediaCentral and Cloud UX environments.",
      <br key={2} />,
      <br key={3} />,
      "My main responsibility is the design and implementation of the front end. I handle both UI and UX, defining interaction flows and translating operational and support-related requirements into clear, efficient, and usable interfaces tailored to real-world technical workflows. In addition to front-end development, I also contribute to the back end by maintaining and improving specific API components and ensuring their correct integration with the front-end application.",
      <br key={4} />,
      <br key={5} />,
      "Development is carried out in close collaboration with a senior developer within a compact team, which allows me to be directly involved across multiple areas of the system and to follow features from design through implementation and delivery. Throughout the project, I gain hands-on experience with modern software development practices, working in Linux-based environments, virtual machines, and containerized systems commonly used in professional enterprise infrastructures. This experience allows me to grow beyond a purely front-end role, strengthening my understanding of the full application stack while maintaining a strong focus on usability, reliability, and long-term maintainability.",
      <br key={6} />,
      <br key={7} />,
      "All work on this project is carried out as part of my employment at Avid Technology (Avid Italy Srl). All intellectual property and product rights belong to the company.",
    ],
  },
  {
    id: 20,
    url: "european-aerosols-magazine-advert",
    title: "European Aerosols: Magazine Advert",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "European Aerosols",
    avatar: [require("../assets/Ruco_AD_Avatar.jpg")],
    images: [
      require("../assets/Ruco_AD_Links.png"),
      require("../assets/Ruco_AD_Graphic.png"),
      require("../assets/Ruco_AD_Mockup.png"),
    ],
    videos: [require("../assets/Ruco_AD_Video.mov")],
    graphicToolsUsed: ["Adobe Photoshop", "Adobe InDesign"],
    codingToolsUsed: [],
    description: [
      "This project involved creating a compelling graphic for an advertisement highlighting the partnership between the European Aerosols Switzerland Department and their client, Ruco.",
      <br key={0} />,
      <br key={1} />,
      "The challenge was to depict the aerosol products in a realistic usage scenario without the aid of 3D rendering tools. Utilizing Adobe Photoshop and advanced photo retouching skills, I meticulously cut around the edges of each product image, adjusting their sizes, lighting, and coloring to seamlessly integrate them into a still life background.",
      <br key={2} />,
      <br key={3} />,
      "This task required a keen eye for detail and a deep understanding of visual composition to achieve a lifelike representation using solely 2D manipulations. The result was a visually stunning advertisement that effectively communicated the partnership's essence and the practical elegance of the aerosol products.",
    ],
  },
  {
    id: 19,
    url: "ysbr-alien-surfer-illustration",
    title: "YSBR: Alien Surfer Illustration",
    location: "Milano, Italy",
    tag: ["Branding", "Illustration"],
    client: "YSBR",
    avatar: [require("../assets/YSBR_Alien-Surfer_Mockup-08.png")],
    images: [
      require("../assets/YSBR_Alien-Surfer_Mockup-01.png"),
      require("../assets/YSBR_Alien-Surfer_Mockup-02.png"),
      require("../assets/YSBR_Alien-Surfer_Mockup-03.png"),
      require("../assets/YSBR_Alien-Surfer_Mockup-04.png"),
      require("../assets/YSBR_Alien-Surfer_Mockup-07.png"),
      require("../assets/YSBR_Alien-Surfer_Mockup-08.png"),
    ],
    graphicToolsUsed: ["Procerate", "Adobe Illustrator"],
    codingToolsUsed: [],
    description: [
      "I had the exhilarating opportunity to design an illustration for YSBR merchandise, they are a brand which organizes dynamic outdoor sports events.",
      <br key={0} />,
      <br key={1} />,
      <Link to="https://www.instagram.com/ysbrfam/" target="_blank" key={0}>
        Visit YSBR Instagram page!
      </Link>,
      <br key={2} />,
      <br key={3} />,
      "This project showcases an imaginative illustration, where an alien is depicted surfing the waves, uniquely propelled by a UFO instead of the traditional kite surf.",
      <br key={4} />,
      <br key={5} />,
      "The design is rendered in a bi-color scheme (client request), making it versatile and easily adaptable to various color palettes.",
      <br key={6} />,
      <br key={7} />,
      "Crafted with textiles in mind, this illustration is perfect for application on t-shirts and jumpers, offering a distinctive and playful addition to any wardrobe."
    ],
  },
  {
    id: 18,
    url: "ysbr-yesbro-flag",
    title: "YSBR: YesBro Flag",
    location: "Milano, Italy",
    tag: ["Branding", "Illustration"],
    client: "YSBR",
    avatar: [require("../assets/YSBR_Dripping-B_W_Flag_Rendering.png")],
    images: [
      require("../assets/YSBR_Dripping-B:W:Flag.png"),
      require("../assets/YSBR_Dripping-B_W_Flag_Rendering.png"),
      require("../assets/YSBR_Dripping-B_W_Flag_Mockup.png"),
    ],
    videos: [require("../assets/YSBR_Dripping-B:W:Flag_Still-Life-Video.mov")],
    graphicToolsUsed: ["Procerate", "Adobe Illustrator"],
    codingToolsUsed: [],
    description: [
      "I had the exciting task of designing a flag for YSBR, a brand known for its thrilling outdoor sports events. Working closely with YSBR, I used Procreate to bring their vision to life, creating a flag that they need to make their presence in events more visible.",
      <br key={0} />,
      <br key={1} />,
      <Link to="https://www.instagram.com/ysbrfam/" target="_blank" key={0}>
        Visit YSBR Instagram page!
      </Link>,
      <br key={2} />,
      <br key={3} />,
      "My focus was on making a design that stands out, blending YSBR's ideas with a black and white graphic (which was a request from the client) used in the negative version to pop up more through the snow (they mainly do ski events and parties).",
      <br key={4} />,
      <br key={5} />,
      "After perfecting the design, I prepared the print files, following precise printer guidelines to ensure quality. You can see the final product above here! I hope that you like it!",
    ],
  },
  {
    id: 17,
    url: "product-display-rendering",
    title: "Product Display Rendering",
    location: "Milano, Italy",
    tag: ["Branding", "Illustration"],
    client: "European Aerosols",
    avatar: [require("../assets/Rendering-Avatar.jpg")],
    images: [
      require("../assets/Can-Rendering.png"),
      require("../assets/Montana-Can.jpg"),
      require("../assets/MONTANA_Rendering-1.png"),
      require("../assets/MONTANA_Rendering-2.png"),
      require("../assets/MONTANA-CAN-RACK-1METER-00.jpg"),
      require("../assets/Rendering-Mockup-1.png"),
      require("../assets/Rendering-Mockup-3.png"),
      require("../assets/Rendering-Mockup-2.png"),
    ],
    graphicToolsUsed: ["Adobe Illustrator"],
    codingToolsUsed: [],
    description: [
      "In this project I had to create a Rendering that shows how these Montana Cans (a brand of European Aerosols) products would display in the client shop.",
      <br key={0} />,
      <br key={1} />,
      "The essence of these renderings lies in their ability to visualize display projects within a shop context, complete with associated merchandise and marketing materials.",
      <br key={2} />,
      <br key={3} />,
      "The graphical representations are meticulously designed to present products as they would appear in an actual retail setting or exhibition. This approach allows for an effective and realistic way of presenting projects to clients.",
      "While maintaining a keen eye on detail, the renderings are crafted to emphasize key aspects such as product colors and the overall coherence of the display, ensuring that the focus remains on the most crucial elements of the project.",
      <br key={6} />,
      <br key={7} />,
      "If you look at the images above you can see a common Montana Cans display which my collaborators gave me to have an idea of how they are usually displayed (for example they prefer to display them with no cap). I created the rendering based on the client racks, the same that they will provide to display the cans. So the final graphic can have 100% fidelity to the real product.",
      <br key={8} />,
      <br key={9} />,
      "This balance of realism and strategic focus makes these renderings an invaluable tool for businesses looking to preview and refine their shop layouts and product presentations.",
    ],
  },

  {
    id: 16,
    url: "jat-job-applications-tracker",
    title: "JAT: Job Applications Tracker",
    location: "Milano, Italy",
    tag: ["Branding", "UI", "UX", "Web Development"],
    client: "JAT",
    avatar: [require("../assets/JAT-Website-2.png")],
    images: [
      require("../assets/JAT_logo&claim.svg").default,
      require("../assets/JAT_logo_B&W-Positive.svg").default,
      require("../assets/JAT_logo_B&W-Negative.svg").default,
      require("../assets/JAT-Website.png"),
      require("../assets/JAT-Website-1.png"),
      require("../assets/JAT_Pattern.png"),
    ],
    graphicToolsUsed: ["Adobe Illustrator"],
    codingToolsUsed: ["HTML", "CSS", "Javascript", "React"],
    description: [
      "JAT, short for Job Application Tracker, is a project born out of a personal journey and a universal need.",
      <br key={0} />,
      <br key={1} />,
      "While navigating the complex process of job applications, I realized the widespread demand for an organized system to track sent CVs and manage job-seeking efforts. This insight led to the creation of JAT, a web application where design meets functionality.",
      <br key={2} />,
      <br key={3} />,
      "I dedicated time to crafting not just a name but also a distinct logo, encapsulating the essence of JAT. The logo shows a magnifying glass with a tick in the middle to symbolize the idea of seeking with certain success and achievement, the green color gives also a secure atmosphere to the graphics, together with the black which maintains a bit of formalization to stick to the Job concept. Developed using React, this project showcases my expertise in UI/UX design, ensuring users enjoy a seamless, effective experience marked by simplicity and aesthetic appeal.",
      <br key={4} />,
      <br key={5} />,
      "Please note, this version of JAT is a demo, functioning without a backend or database, designed to illustrate the potential of this concept in aiding job seekers in their career journey.",
      <br key={6} />,
      <br key={7} />,
      <Link
        to="https://marcoates.github.io/JAT-Job-Application-Tracker/"
        target="_blank"
        key={0}
      >
        <b>Try JAT: Job Application Tracker now!</b>
      </Link>,
    ],
  },

  {
    id: 15,
    url: "abkc-american-bully-kennel-club-pitbull-mascots-illustrations",
    title: "ABKC American Bully Kennel Club: Pitbull Mascots Illustrations",
    location: "Milano, Italy",
    tag: ["Illustration", "Branding"],
    client: "ABKC American Bully Kennel Club",
    avatar: [require("../assets/Tattoed-Pit-photo-1.jpeg")],
    images: [
      require("../assets/Tattoed-Pit.png"),
      require("../assets/Gladiator-Pit.png"),
      require("../assets/Tattoed-Pit-photo-1.jpeg"),
      require("../assets/Tattoed-Pit-photo-2.jpeg"),
      require("../assets/Tattoed-Pit-mug-mockup.png"),
      require("../assets/Gladiator-Pit-photo-1.jpeg"),
      require("../assets/Gladiator-Pit-photo-2.jpeg"),
    ],
    graphicToolsUsed: ["Procreate", "Adobe Illustrator"],
    codingToolsUsed: [],
    description: [
      "I had the honor of creating two compelling Pitbull Mascot Illustrations for the prestigious ABKC American Bully Kennel Club event in Italy. The first illustration showcased a tattooed Pitbull face, exuding a perfect blend of strength and edginess, while the second depicted a fearless Pitbull Gladiator, representing courage and determination.",
      <br key={0} />,
      <br key={1} />,
      "The client sought these illustrations to be suitable on a range of various merchandise. Additionally, the Pitbull Gladiator design was designed in order to become a captivating 3D mascot trophy in the future, which will be awarded to the winner of the American Bullies parade, creating a unique and memorable experience for the recipient.",
      <br key={2} />,
      <br key={3} />,
      "The response to these illustrations was overwhelming, with attendees and participants embracing them as powerful symbols of the breed’s spirit and character.",
      <br key={4} />,
      <br key={5} />,
      "I am immensely proud to have contributed to such a remarkable event, celebrating the beloved American Bullies and fostering a sense of camaraderie within the community.",
    ],
  },

  {
    id: 14,
    url: "dupli-color-il-ritocco-muri-product-label",
    title: "Dupli-Color Il Ritocco Muri: Product Label",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "European Aerosols",
    avatar: [require("../assets/Il-Ritocco-Muri_Mockup.png")],
    images: [
      require("../assets/Il-Ritocco-Muri_Mockup.png"),
      require("../assets/Il-Ritocco-Muri-Label.png"),
    ],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "Embark on a visual journey with the captivating label design for Dupli-Color’s “Il Ritocco Muri” spray product. My goal was to create an eye-catching and informative label that showcases the product’s exceptional ability to isolate and cover wall stains, preparing surfaces for painting.",
      <br key={0} />,
      <br key={1} />,
      "Drawing inspiration from the successful “Il Coprimacchie” project in my portfolio, we established a seamless link between the two products through minimalistic design elements and carefully chosen imagery. By focusing on relevant messages, we crafted a label that effortlessly conveys the essence of both products.",
      <br key={2} />,
      <br key={3} />,
      "Through harmonious graphic elements, our design ensures that important features and benefits are emphasized, guiding your attention to the most vital aspects. Prepare to witness the transformation of your walls unfold before your eyes.",
    ],
  },
  /*
  {
    id: 13,
    url: "todolist-app-web-application",
    title: "ToDoList App: Web Application",
    location: "Milano, Italy",
    tag: ["Web Development"],
    client: null,
    avatar: [require("../assets/ToDoList-App-Image.png")],
    images: [require("../assets/ToDoList-App-Image.png")],
    graphicToolsUsed: [],
    codingToolsUsed: ["HTML", "CSS", "NodeJS", "Javascript", "MongoDB", "Git"],
    description: [
      <Link
        to="https://nice-pink-coypu-kilt.cyclic.app/"
        target="_blank"
        key={0}
      >
        Create your ToDoList!
      </Link>,
      <br key={1} />,
      <br key={2} />,
      "This project is a full-stack ToDoList web application that showcases my expertise in both frontend and backend development. With a focus on creating a seamless user experience, I developed the application following my personal brand guidelines and utilized GitHub for version control.",
      <br key={3} />,
      <br key={4} />,
      "The web app allows users to create and manage task groups with ease. Using JavaScript, Node.js, and Express, I set up a server to handle routing and rendering of different pages. MongoDB Atlas, integrated with Mongoose, serves as the database for securely storing tasks. Additionally, I created a GitHub repository to safely update and make changes to the web app, ensuring a streamlined development process.",
      <br key={5} />,
      <br key={6} />,
      <Link to="https://github.com/marcoates/todolist" target="_blank" key={7}>
        Check the GitHub repo and take a look at the code!
      </Link>,
      <br key={8} />,
      <br key={9} />,
      "Through the Cyclic deployment platform, I deployed the web app, making it accessible to users. Adding a custom task group is as simple as typing /[TASK GROUP NAME] at the end of the URL, enabling users to create personalized task groups. Specific tasks added to a custom group are stored exclusively within that group and are not displayed in other groups.",
      <br key={10} />,
      <br key={11} />,
      "For the frontend development, I designed visually appealing and responsive elements using HTML, CSS, and JavaScript. The seamless integration of frontend and backend components ensures a smooth and intuitive user experience across the ToDoList web app.",
      <br key={12} />,
      <br key={13} />,
      "Overall, this project highlights my proficiency in full-stack development, encompassing frontend design, server setup using JavaScript, Node.js, and Express, integration with MongoDB Atlas and Mongoose for data storage, deployment via Cyclic, and the use of a GitHub repository for version control. The ToDoList web app empowers users to efficiently manage tasks through dynamic task groups, providing a flexible and organized task management system.",
    ],
  },
  */
  {
    id: 12,
    url: "dupli-color-il-copri-macchie-product-label",
    title: "Dupli-Color Il Copri Macchie: Product Label",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "European Aerosols",
    avatar: [require("../assets/Il-Coprimacchie_Mockup.jpg")],
    logoImages: [],
    images: [
      require("../assets/Il-Coprimacchie_Mockup.jpg"),
      require("../assets/Il-Coprimacchie_Label.jpeg"),
    ],
    biggerImages: [],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "The design goal for this project was to create an eye-catching and informative label for Dupli-Color’s “Il Copri Macchie” spray product, which is a white paint that isolates and covers any type of stain on the wall, in order to prepare the surface to be painted.",
      <br key={0} />,
      <br key={1} />,
      "To achieve this, a logo icon was created to represent the “Macchia Block” formula, which effectively make this paint able to blocks stains and even mold from returning on surfaces.",
      <br key={2} />,
      <br key={3} />,
      "Relevant images were also used on the label to complement the information provided together with the design that puts all the answers customers may need directly on the facing of the products.",
    ],
  },

  {
    id: 11,
    url: "breis-beats-logo",
    title: "Breis Beats: Logo",
    location: "Milano, Italy",
    tag: ["Branding", "Illustration"],
    client: "Breis Beats",
    avatar: [require("../assets/Breis-Logo_Negative.jpg")],
    images: [
      require("../assets/Breis-Logo_Positive.png"),
      require("../assets/Breis-Logo_Negative.jpg"),
      [require("../assets/Breis_Youtube.png")],
    ],
    graphicToolsUsed: ["Procreate", "Adobe Illustrator"],
    codingToolsUsed: [],
    description: [
      "I recently had the pleasure of creating a logo for my friend Breis, who produces some seriously sick rap beats.He wanted a simple, signature logo that would be easily recognizable, so I took his signature and transformed it into a sleek design using Adobe Illustrator.",
      <br key={0} />,
      <br key={1} />,
      "If you’re curious to see the final product in action, ",
      <Link to="https://www.youtube.com/@breis_official/videos" target="_blank">
        check out his YouTube channel
      </Link>,
      " and listen to some of his incredible productions. I’m sure you won’t be disappointed!",
    ],
  },

  {
    id: 8,
    url: "drv-logo",
    title: "DRV: Logo",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "DRV Trasporti",
    avatar: [require("../assets/DRV_Logo.png")],
    images: [
      require("../assets/DRV-Mockup-1.jpeg"),
      require("../assets/DRV_Logo.png"),
      require("../assets/DRV-Mockup-2.png"),
      require("../assets/DRV-Photo-1.jpeg"),
      require("../assets/DRV-Photo-2.jpeg"),
      require("../assets/DRV-Photo-3.jpeg"),
    ],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "For DRV Trasporti, a transport company based in Milan, Italy, I created a logo that would represent the company professionally and effectively.",
      <br key={0} />,
      <br key={1} />,
      "Together with the client, we collaborated on the design, deciding on the logo’s shape and colors. My focus was on creating a design that could be easily recognizable and adapted to different surfaces. It was important for the logo to immediately convey what the company does, so I aimed to make it clear and straightforward. I’m grateful for the opportunity to contribute to DRV Trasporti’s success.",
    ],
  },

  {
    id: 7,
    url: "dupli-color-all-season-spray-graphics",
    title: "Dupli-Color: All Season Spray Graphics",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "European Aerosols",
    avatar: [require("../assets/All-Season-Flyer-Mockup-1.jpeg")],
    images: [
      require("../assets/All-Season-Flyer-Mockup-1.jpeg"),
      require("../assets/All-Season-Flyer-Mockup-2.jpeg"),
      require("../assets/All-Season-Flyer-Mockup-3.jpeg"),
      require("../assets/All-Season_Rendering.png"),
      require("../assets/All-Season_Crowner.png"),
    ],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "For the European Aerosols Design Project, my task was to create a comprehensive promotional package for their DUPLI-COLOR sub-brand’s star product, the All Season spray paint. Recognized as the finest external-use spray paint on the market, my challenge was to design a compelling visual representation that would effectively communicate its unique features and advantages.",
      <br key={0} />,
      <br key={1} />,
      "Taking a strategic approach, I aimed to highlight the product's safety, versatility, and efficacy. The design concept I crafted was inspired by the great outdoors, featuring a backdrop reminiscent of clouds, grass, and sunshine, evoking a sense of outdoor activities and enjoyment. To emphasize the product's safety for users of all ages, I incorporated a playful children's toy into the design.",
      <br key={2} />,
      <br key={3} />,
      "In addition to creating an eye-catching leaflet showcasing all available colors and product features, I extended my creativity to craft a detailed rendering displaying how the All Season spray paint assortment would appear inside a retail store. Utilizing my skills in Adobe Illustrator, I meticulously recreated the three-dimensional aspects of the subject, ensuring a lifelike and immersive representation of the product within the store environment. This rendering was complemented by a crowner I designed, featuring graphics that seamlessly integrated with the product-filled racks in stores. This cohesive visual package not only enhanced the product’s appeal but also provided a ready-made graphic pack, optimized for upselling the product.",
      <br key={4} />,
      <br key={5} />,
      "I am immensely proud of the final outcome of this project, aptly titled 'Dupli-Color: All Season Spray Graphics.' This comprehensive approach not only effectively promotes the All Season spray paint but also provides a visually appealing representation of how it can be showcased in retail spaces, ensuring maximum impact and consumer engagement for European Aerosols.",
    ],
  },

  {
    id: 6,
    url: "dupli-color-pricing-list-catalog",
    title: "Dupli-Color: Pricing List Catalog",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "European Aerosols",
    avatar: [
      require("../assets/Dupli-Color-Pricing-List-Catalog_Mockup-1.jpeg"),
    ],
    images: [
      require("../assets/Dupli-Color-Pricing-List-Catalog_Mockup-1.jpeg"),
      require("../assets/Dupli-Color-Pricing-List-Catalog_Mockup-2.jpeg"),
      require("../assets/Dupli-Color-Pricing-List-Catalog_Mockup-3.jpeg"),
    ],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "In this project, I created a pricing list catalog for the European Aerosols’ sub-brand, DUPLI-COLOR. The challenge was to design a graphic concept that could showcase all products along with their pricing, descriptions, and images in a visually appealing and easy-to-read format.",
      <br key={0} />,
      <br key={1} />,
      "To achieve this, I used the corporate colours and maintained brand consistency to create a cohesive link between this catalog and the product catalog. I also made sure to design the layout in a way that would be both functional and exciting for customers to browse through.",
      <br key={2} />,
      <br key={3} />,
      "I’m happy with the final result, and believe that the pricing list catalog will help customers quickly and easily find the products they’re looking for and make informed purchasing decisions.",
    ],
  },

  {
    id: 5,
    url: "dupli-color-products-catalog",
    title: "Dupli-Color: Products Catalog",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "European Aerosols",
    avatar: [require("../assets/Dupli-Color-Product-Catalog_Mockup-2.jpeg")],
    images: [
      require("../assets/Dupli-Color-Product-Catalog_Mockup-1.jpeg"),
      require("../assets/Dupli-Color-Product-Catalog_Mockup-2.jpeg"),
      require("../assets/Dupli-Color-Product-Catalog_Mockup-3.jpeg"),
    ],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "This is a product catalog I designed for European Aerosols’ sub-brand DUPLI-COLOR. My goal was to create a visually appealing layout that effectively showcases the various products’ features, color shades, and descriptions using high-quality images.",
      <br key={0} />,
      <br key={1} />,
      "To maintain brand consistency, I incorporated the corporate colors throughout the catalog and established a connection between this catalog and the pricing list catalog. Overall, the result is a comprehensive and engaging catalog that effectively communicates the unique qualities of each product.",
    ],
  },

  {
    id: 4,
    url: "settimo-tricot-club-logo",
    title: "Settimo Tricot Club: Logo",
    location: "Milano, Italy",
    tag: ["Branding"],
    client: "Settimo Tricot Club",
    avatar: [require("../assets/Settimo-Tricot-Club_Mockup-1.jpg")],
    images: [
      require("../assets/Settimo-Tricot-Club_Logo.png"),
      require("../assets/Settimo-Tricot-Club_Mockup-1.jpg"),
      require("../assets/Settimo-Tricot-Club_Mockup-2.jpg"),
      require("../assets/Settimo-Tricot-Club_Mockup-3.jpg"),
    ],
    graphicToolsUsed: ["Adobe Illustrator", "Adobe Photoshop"],
    codingToolsUsed: [],
    description: [
      "For Settimo Tricot Club, a knitting club in Milan, I designed a flyer that captures the essence of the club through a recognizable image of a ball of wool. The vintage colors used in the design evoke a sense of nostalgia for the original and ancient art of knitting, creating a connection between the past and present. The overall goal was to create an eye-catching and memorable graphic that immediately communicates the essence of the club.",
    ],
  },

  {
    id: 3,
    url: "urmet-iuvs-plus-app",
    title: "Urmet: Iuvs Plus App",
    location: "Milano, Italy",
    tag: ["UI"],
    client: "Urmet",
    avatar: [require("../assets/Urmet-Iuvs-Plus_Logo.png")],
    images: [],
    graphicToolsUsed: ["Adobe Illustrator", "Sketch"],
    codingToolsUsed: [],
    description: [
      "As a UI designer, I played a crucial role in developing an innovative app for Urmet, an Italian company specializing in high-value building communication and security systems. Working closely with the UX Designer, I brought my expertise in UI design to create visually stunning graphics and interfaces that met the client’s requirements.",
      <br key={0} />,
      <br key={1} />,
      "My responsibilities included designing all the icons and buttons for Urmet’s app “Iuvs Plus,” which is used to control home automation. To ensure that the end product was top-notch, I maintained constant communication with the developers despite working remotely.",
      <br key={2} />,
      <br key={3} />,
      "Throughout the project, I prioritized the user experience by implementing intuitive interfaces and easy-to-use navigation. I also incorporated the client’s brand identity and color scheme, resulting in a cohesive and professional-looking design.",
      <br key={4} />,
      <br key={5} />,
      "In the end, the app received positive feedback from both the client and end-users for its visually appealing and user-friendly design. My contribution as a UI designer played a pivotal role in delivering a cutting-edge product that met the client’s expectations.",
    ],
  },

  {
    id: 2,
    url: "pixxa-challenge-blackboard-and-instructions-flyer",
    title: "Pixxa: Challenge Blackboard and Instructions Flyer",
    location: "London, UK",
    tag: ["Branding", "Illustration"],
    client: "Pixxa Ltd",
    avatar: [require("../assets/Pixxa-Challenge_Board_Photo-1.jpeg")],
    images: [
      require("../assets/Pixxa-Challenge_Board.png"),
      require("../assets/Pixxa-Challenge_Rules-Flyer.png"),
      require("../assets/Pixxa-Challenge_Board_Photo-1.jpeg"),
      require("../assets/Pixxa-Challenge_Board_Photo-2.jpeg"),
      require("../assets/Pixxa-Challenge_Rules-Flyer_Photo-1.jpeg"),
    ],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "I created this graphic for PIXXA Ltd, a pizza by-the-slice restaurant based in London.",
      <br key={0} />,
      <br key={1} />,
      "The graphic consists of a set of icons, characters, and graphics designed to represent the PIXXA Challenge concept. This challenge invites customers to eat 6 slices of PIXXA within 9 minutes, beating the record displayed on the board, in order to win a free 6 slices of PIXXA.",
      <br key={2} />,
      <br key={3} />,
      "To achieve a rustic effect that complements the restaurant’s decor, I printed the graphic on vinyl using a plotter and then applied it to a black-painted wooden board. Flyers were printed on plasticized paper, making them a cost-effective promotional tool that customers could take home with them.",
    ],
  },

  {
    id: 1,
    url: "pixxa-journey-blackboard",
    title: "Pixxa: Journey Blackboard",
    location: "London, UK",
    tag: ["Branding", "Illustration"],
    client: "Pixxa Ltd",
    avatar: [require("../assets/Pixxa-Journey_Board_Photo-1.jpeg")],
    images: [
      require("../assets/Pixxa-Journey_Board.png"),
      require("../assets/Pixxa-Journey_Board_Photo-1.jpeg"),
      require("../assets/Pixxa-Journey_Board_Photo-2.jpeg"),
      require("../assets/Pixxa-Journey_Board_Photo-3.jpeg"),
    ],
    graphicToolsUsed: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingToolsUsed: [],
    description: [
      "I designed a graphic for PIXXA, a pizza by-the-slice restaurant based in London, which showcases every step of the pizza making journey and recipe.",
      <br key={0} />,
      <br key={1} />,
      "The graphic set includes icons that depict the process of making the dough in the kitchen to the final pizza on the plate. I used a plotter to print the graphic on vinyl and then stuck it onto a black painted wooden board to create a rustic blackboard effect that perfectly suits the ambiance of a pizza place.",
    ],
  },
];
